import { render, staticRenderFns } from "./SetPopup.vue?vue&type=template&id=9959ce38"
import script from "./SetPopup.vue?vue&type=script&lang=js"
export * from "./SetPopup.vue?vue&type=script&lang=js"
import style0 from "./SetPopup.vue?vue&type=style&index=0&id=9959ce38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports